import React, { useState, useRef } from 'react'
import FirstPageIcon from '@mui/icons-material/FirstPage'
import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft'
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight'
import LastPageIcon from '@mui/icons-material/LastPage'
import CalendarTodayIcon from '@mui/icons-material/CalendarToday'
import { Input, FormControl, InputAdornment, IconButton, Popper, ClickAwayListener } from '@mui/material'
import { Button } from 'reactstrap'
import moment from 'moment-timezone'
import { DayPicker } from 'react-day-picker'
import 'react-day-picker/dist/style.css'
import { fi } from 'date-fns/locale/fi'

function DateNavigation({ selectedDate, moveDate, handleDateChange, isMobile }) {
  const [anchorEl, setAnchorEl] = useState(null)
  const [isPopperOpen, setIsPopperOpen] = useState(false)
  const anchorRef = useRef(null)

  const datenavidation = { cursor: 'pointer', margin: isMobile ? 4 : 10 }

  const handleDateSelectOpen = (event) => {
    setAnchorEl(event.currentTarget)
    setIsPopperOpen(true)
  }

  const closePopper = () => {
    setIsPopperOpen(false)
  }

  const handleDaySelect = (date) => {
    if (date) {
      const d = date.getDate()
      const m = date.getMonth()
      const y = date.getFullYear()
      const formattedDate = `${y}-${String(m + 1).padStart(2, '0')}-${String(d).padStart(2, '0')}`
      // Create a synthetic event to match the expected interface
      handleDateChange({ target: { value: formattedDate } })
      closePopper()
    }
  }

  return (
    <div>
      <div>
        <strong style={{ textTransform: 'capitalize' }}>
          {moment.utc(selectedDate).format('dddd')}
        </strong>
      </div>
      <div style={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap' }}>
        <FormControl variant='standard' style={{ display: 'inline-flex' }}>
        <Input
          size='small'
          id='date-navigation-input'
          type='text'
          readOnly
          style={{ width: 120 }}
          value={moment.utc(selectedDate).format('D.M.YYYY')}
          endAdornment={
            <InputAdornment position='end'>
              <IconButton aria-label='dateselect' onClick={handleDateSelectOpen} size='small'>
                <CalendarTodayIcon style={{ fontSize: 15, color: 'black' }} />
              </IconButton>
            </InputAdornment>
          }
        />
      </FormControl>
      <div ref={anchorRef}></div>

      <Popper open={isPopperOpen} anchorEl={anchorEl} placement="bottom-start" style={{ zIndex: 1300 }}>
        <ClickAwayListener onClickAway={closePopper}>
          <div style={{ backgroundColor: 'white', borderRadius: 10, boxShadow: '0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)' }}>
            <DayPicker
              initialFocus={isPopperOpen}
              mode="single"
              defaultMonth={moment.utc(selectedDate).toDate()}
              selected={moment.utc(selectedDate).toDate()}
              onSelect={handleDaySelect}
              showWeekNumber
              weekStartsOn={1}
              locale={fi}
            />
          </div>
        </ClickAwayListener>
      </Popper>

      <FirstPageIcon onClick={() => moveDate(-7)} style={datenavidation} />
      <KeyboardArrowLeftIcon
        onClick={() => moveDate(-1)}
        style={datenavidation}
      />
      <Button
        size='sm'
        outline
        style={{ margin: 10 }}
        onClick={() => moveDate(0)}
      >
        Tänään
      </Button>
      <KeyboardArrowRightIcon
        onClick={() => moveDate(1)}
        style={datenavidation}
      />
      <LastPageIcon onClick={() => moveDate(7)} style={datenavidation} />
      </div>
    </div>
  )
}

export default DateNavigation
